import { IPlanEnrollment, IPlanEnrollmentCreateRequest } from "./types";
import { planEnrollmentService } from "./service";

export const createPlanEnrollment = async (
  request: IPlanEnrollmentCreateRequest
): Promise<IPlanEnrollment> => {
  const { data } = await planEnrollmentService.post(``, request);
  return data;
};
